import React from 'react';
import Notes from './steps/notes';
import Particulars from './steps/particulars';

import l10n from './localization';
import Form from '../form';

import { joinString } from '../../utilities/commonUtil';

export const localization = l10n;

export const inputSteps = [
    Notes,
    Particulars,
];

export const Intro = () => {
    return (
        <>
            <p />
        </>
    );
}

export const form = {
    steps: inputSteps,
    screenId: "LROLS7",
    code: "LROLS7",
    reference: "LR/OLS/7 (06/2024)",
    validFrom: "2020/11/05",
    intro: Intro,
    localization: localization,
    signRequired: false,
    emeRequired: true,
    submitDateId: formData => "Enquiry Date 查詢日期",
    paymentRequired: false, 
    resumeFromStepIdx: 2,
    resumeRetainFormDataKeys: [ 
                                "PICS",
                                "ackEmail",
                                "receiveAckEmail",
                            ],
    submitTransformFunc: (formData, dispatch) => {
        let newFormData = {...formData};
        newFormData.DateTimeOfOrder = joinString([formData.DateOfOrder, formData.TimeOfOrder], " ");

        if(formData.ClaimAmount != undefined) {
            var _claimAmount = parseInt(formData.ClaimAmount);
            newFormData.ClaimAmount = _claimAmount.format(2, 3, ',', '.');
        }

        if(formData["ImageProblem"]) {
            if (formData["NaN_Image_Opt_3$strike"] == "keep") {
                newFormData["NaN_Image_Opt_4$strike"] = "strike";
            }
            else {
                newFormData["NaN_Image_Opt_4$strike"] = "keep";
            }
        }

        return newFormData;
    }
}



export default ({currentLang}) => <Form form={form} currentLang={currentLang} />;